<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 5C4 4.44772 4.44772 4 5 4H15C15.5523 4 16 4.44772 16 5C16 5.55228 15.5523 6 15 6H5C4.44772 6 4 5.55228 4 5Z"
      fill="currentColor"
    />
    <path
      d="M4 15C4 14.4477 4.44772 14 5 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H5C4.44772 16 4 15.5523 4 15Z"
      fill="currentColor"
    />
    <path
      d="M4 10C4 9.44772 4.44772 9 5 9H15C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H5C4.44772 11 4 10.5523 4 10Z"
      fill="currentColor"
    />
  </svg>
</template>
